<template>
    <div class="container" :class="{ 'dark-mode': isDarkMode }">
        <div class="intro" data-aos="fade-down" data-aos-easing="ease-in-out" data-aos-duration="800"
            data-aos-anchor-placement="top">
            <p class="section_p1">Offerable</p>
            <h1 class="title">Services</h1>
        </div>
        <div class="service-box">
            <div class="card" v-for="(service, index) in servicesData" :key="index" data-aos="flip-left"
                data-aos-easing="ease-in-out" data-aos-duration="900" data-aos-anchor-placement="top-center">
                <i :class="service.icon"></i>
                <h3>{{ service.title }}</h3>
                <p>{{ service.data }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'Services',
    data() {
        return {
            servicesData: [
                { icon: 'fa-solid fa-binoculars', title: 'Freelancing', data: "I'm a dedicated freelancer in the field of web development, ready to collaborate on projects, deliver quality work, and turn your ideas into digital reality." },
                { icon: 'fa-solid fa-code', title: 'Web Design', data: 'I offer a variety of web development services, with expertise in front-end and back-end development, responsive web design, custom web applications, and proactive website maintenance.' },
                { icon: 'fa-solid fa-clone', title: 'Prototyping', data: 'I have expertise in creating web prototypes, where I transform your ideas into models that demonstrate the possibilities of your web projects.' },
            ]
        }
    },

    computed: {
        ...mapState(['isDarkMode'])
    }
}
</script>

<style lang="scss" scoped>
.container {
    padding-top: 4vh;
    width: 100%;
    min-height: 100vh;
    height: 100%;

    .service-box {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        grid-gap: 2rem;
        padding: 5% 0;

        .card {
            position: relative;
            flex: 1 1 18rem;
            padding: 2rem 1rem 2rem;
            text-align: center;
            background: rgba(255, 255, 255, 0.37);
            backdrop-filter: blur(9px);
            transition: transform .7s;
            border-radius: 10px;
            
            

            i {
                padding: 1.7rem;
                background: black;
                color: white;
                align-items: center;
                font-size: 2rem;
                border-radius: 50%;
                position: relative;
                outline: 3px solid rgba(255, 255, 255, 0.164);
            }

            h3 {
                margin-top: 10px;
                font-size: 1.5rem;
                color: black;
            }

            p {
                margin: .5rem 0 1.5rem 0;
                font-weight: 300;
                letter-spacing: 1px;
                line-height: 1.6;
            }

            &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                background: black;
                width: 0;
                height: 100%;
                z-index: -1;
                transition: .3s;
                border-radius: 10px;
            }

            &:hover::before {
                width: 100%;
            }

            &:hover {

                p,
                h3 {
                    color: white;
                }

                i {
                    outline: 3px solid rgba(179, 179, 179, 0.616);
                    border: 2px solid black;
                    background: white;
                    color: black;
                }


                transform: translateY(-.7rem);
                box-shadow: 0 0 10px rgba(13, 0, 0, 1),
                0px 0px 21px rgba(13, 0, 0, 0.078),
                0px 0px 24px rgba(13, 0, 0, 0.082),
                0px 1px 4px rgba(13, 0, 0, 0.016);

                @media(max-width: 750px) {
                    box-shadow: 0 0 5px rgba(13, 0, 0, 1),
                    0px 0px 25px rgba(13, 0, 0, 0.6);
                }
            }
        }
    }
}

.dark-mode {
    .service-box {
        .card {
            background: rgba(255, 255, 255, 0.164);
            backdrop-filter: blur(9px);

            i {
                background: white;
                color: black;
                outline: 3px solid rgba(255, 255, 255, 0.164);
            }

            h3 {
                margin-top: 10px;
                font-size: 1.5rem;
                color: white;
            }

            &::before {
                background: white;
            }

            &:hover::before {
                width: 100%;
            }

            &:hover {

                p,
                h3 {
                    color: rgb(32, 32, 32);
                }

                i {
                    outline: 3px solid rgba(179, 179, 179, 0.616);
                    border: 2px solid white;
                    background: black;
                    color: white;
                }

                box-shadow: 0 0 10px rgba(255, 255, 255, 1),
                0 0 21px rgba(255, 255, 255, 0.8),
                0 0 24px rgba(255, 255, 255, 0.6),
                0 0 4px rgba(255, 255, 255, 0.4);

                @media(max-width: 750px) {
                    box-shadow: 0 0 8px rgba(255, 255, 255, 1),
                    0 0 25px rgba(255, 255, 255, 0.6);
                }
            }
        }
    }
}
</style>